import React, {useState}from 'react'
import {gql, useMutation,useQuery} from "@apollo/client";
import '../App.css'

const CREAR_SALIDA = gql`
mutation crearSalida($fecha: String, $concepto:String, $cantidad:Int){
   crearSalida(fecha: $fecha, concepto:$concepto, cantidad:$cantidad){
    _id
    fecha
    concepto
    cantidad
   } 
}`

const GET_SALIDA = gql `
query getSalidas{
  getSalidas{
    _id
   fecha
   concepto
   cantidad
  } 
}`



const ELIMINAR_SALIDA = gql`mutation eliminarSalida($id:ID!){
  eliminarSalida(_id:$id)
  }`



function AgregarSalida() {
  const  [fecha, setFecha]=useState('');
  const [concepto, setConcepto] = useState('');
  const [cantidad, setCantidad] = useState();
  const [crearSalida]=useMutation(CREAR_SALIDA, {
    refetchQueries: [{ query: GET_SALIDA }],  // Refresca la lista de tarjetas después de agregar una nueva
});

  const salidaSubmit = e=>{
    e.preventDefault()
    crearSalida({variables:{fecha, concepto,cantidad}});
    setFecha('');
    setConcepto('');
    setCantidad(0);
  }

  const {loading, error, data} = useQuery(GET_SALIDA);
   

    
    const [eliminarSalida] = useMutation(ELIMINAR_SALIDA, {
      refetchQueries: [{ query: GET_SALIDA }]
    });
   
 
  
      
    if(loading) return <p>Esperando resultados...</p>;
        if(error) return <p>Error</p>;

        const currentDate = new Date().toISOString().split('T')[0];


        const filterData = data.getSalidas.filter((item) => item.fecha === currentDate);
        const reversedData = filterData.slice().reverse();
        const totalSalidas = data.getSalidas.reduce((acumulador, salida) => acumulador + salida.cantidad, 0)
      
  return (
    <div>
    <div className="card card-total">
  <h1>total egresos</h1>
<h1>{totalSalidas}</h1>
</div>
<div class="card card-salida" >
  <div class="card-body">
    <h2 class="card-title">Agregar egresos</h2>
    <form onSubmit={salidaSubmit}>
  <input type="date" placeholder='fecha' value={fecha} onChange={evt=>setFecha(evt.target.value)}></input>
  <input placeholder='concepto' value={concepto} onChange={evt=>setConcepto(evt.target.value)}></input>
  <input placeholder='cantidad' value={cantidad} onChange={evt=>setCantidad(parseInt(evt.target.value))}></input>
    <button className="btn btn-salida">Agregar</button>
      
      </form>
      
  </div>

  
</div>
<div class="container">
  <div className="row">   
 {reversedData.map((salida)=>
    
    <><div className="card card-salida col-xs-12 col-xl-4 col-sm-6" >
  <div className="card-body">
    <h3 class="card-title">{salida.concepto}</h3>
    <h4 class="card-text">{salida.fecha}</h4>
    <h4 class="card-text">{salida.cantidad}</h4>
    <button className="btn btn-danger" onClick={()=>{
  eliminarSalida({ variables:{id:salida._id} });
}}  disabled={loading}>
eliminar
 </button>
  </div>
  
</div>



  </>
 
 
 )};
 
 </div>
 </div>
  </div>  
    
  )
}

export default AgregarSalida